import { THINKING, type Thinking } from "@rally/agreed";
import { StepSlider } from "@rally/ui-kit";
import { thinkingLabel } from "../localization/labels.ts";
import { say } from "../localization/say.ts";

export function Effort({
  offered,
  value,
  onChange,
  testID = "effort",
}: {
  offered: readonly Thinking[];
  value: Thinking;
  onChange: (next: Thinking) => void;
  testID?: string;
}) {
  const shown = THINKING.filter((one) => one !== "on" || offered.includes("on"));
  return (
    <StepSlider
      testID={testID}
      label={say("agent.thinkingLevel")}
      value={value}
      onChange={onChange}
      note={
        offered.length > 1
          ? say(`effort.why.${value}`)
          : `${say(`effort.why.${value}`)} ${say("effort.notOffered")}`
      }
      steps={shown.map((one) => ({
        value: one,
        label: thinkingLabel(one),
        held: offered.includes(one),
      }))}
    />
  );
}
